import { render, staticRenderFns } from "./BankInfoAllTabs.vue?vue&type=template&id=6213105b"
import script from "./BankInfoAllTabs.vue?vue&type=script&lang=js"
export * from "./BankInfoAllTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports